import { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';

const inp = (v, on, id) => <input type="text" inputMode="decimal" data-testid={id} value={String(v).replace('.', ',')} onChange={(e) => on(e.target.value.replace(/[^\d.,-]/g, ''))} />;

// blank profile: hydrant (valley) elevation, tank elevation, length -> two-point profile, refine by clicking
export function LabNew({ t, onCreate }) {
  const [v, setV] = useState({ name: '', top: '300', bot: '270', len: '1000' });
  const set = (k) => (x) => setV((o) => ({ ...o, [k]: x }));
  return (
    <div className="lab-new" data-testid="lab-new">
      <label>{t.labName}<input data-testid="lab-new-name" value={v.name} placeholder={t.labProf} onChange={(e) => set('name')(e.target.value)} /></label>
      <label>{t.labTopZ}{inp(v.top, set('top'), 'lab-new-top')} m</label>
      <label>{t.labBotZ}{inp(v.bot, set('bot'), 'lab-new-bot')} m</label>
      <label>{t.labLen}{inp(v.len, set('len'), 'lab-new-len')} m</label>
      <button className="btn btn-accent btn-sm" data-testid="lab-new-create" onClick={() => onCreate(v)}><Plus size={14} /> {t.labCreate}</button>
    </div>
  );
}

// table of profile points (distance from hydrant, elevation); first row = hydrant, last = tank
export function LabProfEd({ t, prof, onChange }) {
  const pts = prof.pts || [], num = (x) => (/^-?\d+([.,]\d+)?$/.test(x) ? +x.replace(',', '.') : x), put = (i, j, x0, x = num(x0)) => onChange({ pts: pts.map((p, k) => (k === i ? (j ? [p[0], x] : [x, p[1]]) : p)) });
  const add = () => { const n = pts.length, a = pts[n - 2] || [0, 0], b = pts[n - 1] || a; onChange({ pts: [...pts.slice(0, -1), [Math.round((+a[0] + +b[0]) / 2), Math.round((+a[1] + +b[1]) / 2)], b] }); };
  return (
    <div className="lab-pts" data-testid="lab-pts">
      <b>{t.labPts}</b>
      {pts.map((p, i) => (
        <div key={i} className="lab-pt" data-testid={`lab-pt-${i}`}>
          <span>{i === 0 ? t.labHyd : i === pts.length - 1 ? t.labTank : `${t.labAddPt} ${i}`}</span>
          {inp(p[0], (x) => put(i, 0, x), `lab-pt-s-${i}`)} m
          {inp(p[1], (x) => put(i, 1, x), `lab-pt-z-${i}`)} m
          <button className="icon-btn" data-testid={`lab-pt-del-${i}`} disabled={pts.length <= 2} onClick={() => onChange({ pts: pts.filter((_, k) => k !== i) })}><Trash2 size={14} /></button>
        </div>
      ))}
      <button className="btn btn-outline btn-sm" data-testid="lab-pt-add" onClick={add}><Plus size={14} /> {t.labAddPt}</button>
    </div>
  );
}
